import BathSpaSection from './BathSpaSection';

export default BathSpaSection;
